import React from "react"
import LinkButton from "@components/common/LinkButton"
import SoftDropdownButton from "../../common/SoftDropDownButton"

const MainMenu = ({
	openMegaMenu,
	handleMenu,
	openCollabMenu,
	handleCollabMenu,
}) => {
	return (
		<React.Fragment>
			<section className="relative gap-x-6 text-black text-sm ml-8">
				{/* DESKTOP */}
				<section className="hidden lg:flex justify-between flex-row items-start lg:items-center max-w-[1440px] mx-auto flex-1 gap-x-6 xl:gap-x-8 gap-y-8">
					<SoftDropdownButton
						label={"SHOP"}
						onClick={handleMenu}
						disableDefaultDropdown={true}
						openOnHover={true}
						className={"flex-1 justify-between"}
						isOpenRef={openMegaMenu}
					/>
					{process.env.GATSBY_STORE !== "PH" ? (
						<>
							<LinkButton
								className={"font-bold text-orange-600"}
								label={"SUMMER SALE"}
								to={"/collections/last-chance-summer-sale/"}
								ariaLabel="SUMMER SALE"
							/>
							<LinkButton
								className={"font-bold text-pink-600"}
								label={"$60 SETS"}
								to={"/collections/60-sets/"}
								ariaLabel="$60 SETS"
							/>
							{/* <LinkButton
								className="font-bold uppercase text-[#502777]"
								label={"BRATZ® X BLACKBOUGH "}
								to={"/collections/bratz/"}
								ariaLabel="BRATZ® X BLACKBOUGH"
							/> */}
							
							<LinkButton
								label={"BEST SELLERS"}
								to="/collections/bestsellers"
								ariaLabel="BEST SELLERS"
							/>
							<SoftDropdownButton
								label={"COLLABS"}
								onClick={handleCollabMenu}
								disableDefaultDropdown={true}
								openOnHover={true}
								className={"flex-1 justify-between"}
								isOpenRef={openCollabMenu}
							/>
							<LinkButton
								label={"LOOKBOOK"}
								to="/lookbooks/"
								ariaLabel="LOOKBOOK"
							/>
						</>
					) : (
						<>
							<LinkButton
								className={"font-bold text-danger"}
								label={"SALE"}
								to={"/collections/sale"}
								ariaLabel="SALE"
							/>

							<LinkButton
								label={"BEST SELLERS"}
								to="/collections/bestsellers"
								ariaLabel="BEST SELLERS"
							/>

							<SoftDropdownButton
								label={"COLLABS"}
								onClick={handleCollabMenu}
								disableDefaultDropdown={true}
								openOnHover={true}
								className={"flex-1 justify-between"}
								isOpenRef={openCollabMenu}
							/>

							<LinkButton
								label={"LOOKBOOK"}
								to="/lookbooks/"
								ariaLabel="LOOKBOOK"
							/>

							<LinkButton
								className="font-bold uppercase text-[#502777]"
								label={"BRATZ® X BLACKBOUGH "}
								to={"/collections/bratz/"}
								ariaLabel="BRATZ® X BLACKBOUGH "
							/>
							
							<LinkButton
								label={"NEW"}
								to={"/collections/new-arrivals/"}
								ariaLabel="NEW"
							/>
						</>
					)}
				</section>
			</section>
		</React.Fragment>
	)
}

export default MainMenu
